// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"2f8f32ec","323":"c73be366","7814":"552bb5fe"}[chunkId] + ".chunk.css";
};